import { useNavigate, useSearchParams } from 'react-router-dom';
import UsersPage from '../Users/UsersPage';
import GroupsPage from '../Groups/GroupsPage';
import useGetRole from '../../API/hooks/useGetRole';
import Tabs from '../../components/common/Tabs/Tabs';
import { FeaturesManagement } from '../../featuresControl';

function UsersPageWrapper(): JSX.Element {
  return <UsersPage />;
}
function GroupsPageWrapper(): JSX.Element {
  return <GroupsPage />;
}

function UsersManagement(): JSX.Element {
  const { isFleetViewer } = useGetRole();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const activeTab = params.get('tab');

  const tabsContent = [];

  if (FeaturesManagement.features.userManagement) {
    tabsContent.push({
      label: 'Users',
      id: 'users',
      content: <UsersPage />,
    });
  }

  if (FeaturesManagement.features.groups && !isFleetViewer) {
    tabsContent.push({
      label: 'Groups',
      id: 'groups',
      content: <GroupsPage />,
    });
  }

  return (
    <Tabs
      tabs={tabsContent}
      activeId={activeTab || tabsContent?.[0]?.id}
      onChange={(tab: string) => navigate(`/management?tab=${tab}`, { replace: true })}
    />
  );
}

export default UsersManagement;
